module.exports = __webpack_public_path__ + "static/img/img_culture_c.f50cadd4.png";